'use client';

import React, { FC } from 'react';
import PDPPopups, { PopupsProps } from 'components/commercetools-ui/organisms/product/popups';
import { TasticProps } from 'frontastic/tastics/types';

const PDPPopupsTastic: FC<TasticProps<PopupsProps>> = ({ data }) => {
  return <PDPPopups data={data?.data?.dataSource} />;
};

export default PDPPopupsTastic;